import { graphql } from 'react-relay';

export const nftSecondaryMarketModalQuery = graphql`
    query nftSecondaryMarketModalQuery(
        $nftItemId: String!
        $userId: String!
        $fetchSplitName: Boolean = false
        $fetchUser: Boolean = true
    ) {
        viewer {
            nftItems(nftIds: [$nftItemId]) {
                ...NftSecondaryMarketModal_nftItem
            }
            ...useMarketContext_viewer
            ...NftSecondaryMarketModalContent_viewer
        }
    }
`;
